"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingThread = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const stream_chat_react_1 = require("stream-chat-react");
const GamingMessage_1 = require("./GamingMessage");
const GamingMessageInput_1 = require("./GamingMessageInput");
const GamingThread = () => {
    return (0, jsx_runtime_1.jsx)(stream_chat_react_1.Thread, { Message: GamingMessage_1.GamingMessage, Input: GamingMessageInput_1.GamingMessageInput });
};
exports.GamingThread = GamingThread;
